import { render, staticRenderFns } from "./BaseSmallChip.vue?vue&type=template&id=9d868bce&scoped=true"
import script from "./BaseSmallChip.vue?vue&type=script&lang=js"
export * from "./BaseSmallChip.vue?vue&type=script&lang=js"
import style0 from "./BaseSmallChip.vue?vue&type=style&index=0&id=9d868bce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d868bce",
  null
  
)

export default component.exports